var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"type":_vm.type,"value":_vm.textValue,"readonly":_vm.readonly},on:{"keyup":_vm.userInput}})}
var staticRenderFns = []

export { render, staticRenderFns }